'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Nav", {
    enumerable: true,
    get: function() {
        return Nav;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNav = require("./useNav");
const _renderNav = require("./renderNav");
const _useNavStylesstyles = require("./useNavStyles.styles");
const _useNavContextValues = require("../useNavContextValues");
const Nav = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNav.useNav_unstable)(props, ref);
    const contextValues = (0, _useNavContextValues.useNavContextValues_unstable)(state);
    (0, _useNavStylesstyles.useNavStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useHamburgerStyles_unstable')(state);
    return (0, _renderNav.renderNav_unstable)(state, contextValues);
});
Nav.displayName = 'Nav';
